define.alias("shared/components/shared/wizards/carousel/step-three", "settings/components/shared/wizards/carousel/step-three");